import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-active-user',
  templateUrl: './active-user.component.html',
  styleUrls: ['./active-user.component.scss'],
})
export class ActiveUserComponent implements OnInit {
  @Input() state: any;
  @Input() show: any;
  @Input() showRol: any[] = [];

  constructor(
    private popoverController: PopoverController
  ) { }

  ngOnInit() {}

  setState(ev){
    this.popoverController.dismiss(ev.detail.value);
  }
}
